import { render } from "./MobileBottomNav.vue?vue&type=template&id=a3d1cd9e&scoped=true"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"

import "./MobileBottomNav.vue?vue&type=style&index=0&id=a3d1cd9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d1cd9e"]])

export default __exports__